import './styles/index.scss'

import './styles/iview/theme.less'

import iView from 'iview'

import 'animate.css/animate.min.css' // animate css 动画

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import ZNav from './components/nav'
import ZProject from './components/project'
import ZDialog from './components/dialog'
import ZPanelimg from './components/panelimg'
import ZAddress from './components/address'
import ZPage from './components/page'
import ZUpload from './components/upload'
import ZEmpty from './components/empty'
import Z404 from './components/404'
import ZAiffx from './components/afifx'
import ZSteps from './components/steps'
import ZUserads from './components/user-ads'
import ZUserupload from './components/user-upload'
import ZContract from './components/contract'
import ZTabs from './components/tabs'
import ZSwitchimg from './components/switchImg'
import ZContactbox from './components/contact-box'
import ZFooter from './components/footer'
import ZLeftMenu from './components/left-menu'
import ZSearch from './components/search'
import ZAffixTopBtn from './components/affix-top-btn'
import ZToggleFold from './components/toggle-fold'

const ZhulogicModule = {
  ZNav,
  ZProject,
  ZDialog,
  ZProjectlog: ZDialog.project,
  ZFavoritelog: ZDialog.favorite,
  ZAddProlog: ZDialog.addpro,
  ZSpeclog: ZDialog.spec,
  ZInprojectlog: ZDialog.inproject,
  ZAddresslog: ZDialog.address,
  ZInvoicelog: ZDialog.invoice,
  ZAddFavorites: ZDialog.addFavorites,
  ZAddMembers: ZDialog.addMembers,
  ZMateriallog: ZDialog.materiallog,
  ZLogin: ZDialog.login,
  ZPanelimg,
  ZAddress,
  ZPage,
  ZUpload,
  ZEmpty,
  Z404,
  ZAiffx,
  ZSteps,
  ZStepsMany: ZSteps.many,
  ZUserads,
  ZUserupload,
  ZContract,
  ZTabs,
  ZSwitchimg,
  ZContactbox,
  ZFooter,
  ZLeftMenu,
  ZSearch,
  ZAffixTopBtn,
  ZToggleFold,
}

Object.assign(ZhulogicModule, iView)

const install = function(Vue, options = {}) {
  if (install.installed) return
  Vue.use(Viewer)
  Object.keys(ZhulogicModule).forEach((key) => {
    Vue.component(key, ZhulogicModule[key])
  })

  Vue.prototype.$Message = iView['Message']
  Vue.prototype.$Loading = iView['LoadingBar']
  Vue.prototype.$Modal = iView['Modal']
  Vue.prototype.$Notice = iView['Notice']
  Vue.prototype.$Spin = iView['Spin']
}

// 判断是否是直接引入文件
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

ZhulogicModule.install = install
ZhulogicModule.Circle = ZhulogicModule['Circle']
ZhulogicModule.iCircle = ZhulogicModule['Circle']
ZhulogicModule.iSwitch = ZhulogicModule['Switch']
ZhulogicModule.Message = ZhulogicModule['Message']
ZhulogicModule.Loading = ZhulogicModule['LoadingBar']

export default ZhulogicModule
